module.exports = __webpack_public_path__ + "img/promo5.d319a829.jpg";